<div *ngIf="this.form" class="table_principal">
  <div *ngIf="this.form.get('id').value" >
    
    <div class="col-sm-12">
      <h3>Structure de l'activité {{this.data.activite.code}} {{this.data.activite.libelle}}</h3>
    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">
        <div class="col-md-12 mat-table">
          <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl" class="example-tree" >
            
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
              <ul>
                <li class="mat-tree-node">
                  <button mat-icon-button disabled></button>
                  {{node.code}} - {{node.libelle}} 
                  <button mat-icon-button *ngIf="node.type !== 'Categorie'"><mat-icon (click)="add(node)">add</mat-icon></button>
                  <button mat-icon-button ><mat-icon (click)="edit(node)">edit</mat-icon></button>
                  <button mat-icon-button *ngIf="node.type !== 'Activite'"><mat-icon (click)="delete(node)">remove</mat-icon></button>
                </li>
              </ul>
            </mat-tree-node>
            
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
              <ul>
                <li>
                  <div class="mat-tree-node">
                    <button mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.libelle">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    {{node.code}} - {{node.libelle}}
                    <button mat-icon-button ><mat-icon (click)="add(node)">add</mat-icon></button>
                    <button mat-icon-button ><mat-icon (click)="edit(node)">edit</mat-icon></button>
                    <button mat-icon-button *ngIf="!hasChild(0, node)"><mat-icon (click)="delete(node)">remove</mat-icon></button>
                  </div>
        
                  <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul> 
                </li>
              </ul>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      </form>
  
    <div class="col-sm-12 row" style="display: flex; justify-content: right;">
      <div class="col-sm-6 text-center" style="margin-top: 24px;">
        <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
      </div>
    </div>
  </div>
</div>

  